export default [
  {
    path: '/group-certificate',
    name: 'group-certificate',
    component: () => import('@/views/group-certificate/GroupCertificate.vue'),
  },
  {
    path: '/group-certificate/add',
    name: 'add-group-certificate',
    component: () => import(
      '@/views/group-certificate/control-group-certificate/AddEditGroupCertificate.vue'
    ),
    meta: {
      title: 'Add Group Certificate ',
      requiresAuth: true,
      action: 'create',
      resource: 'Group Certificate',
      pageTitle: 'Group Certificate',
      breadcrumb: [
        {
          text: 'Group Certificate',
          to: '/group-certificate',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/group-certificate/edit/:id',
    name: 'edit-group-certificate',
    component: () => import(
      '@/views/group-certificate/control-group-certificate/AddEditGroupCertificate.vue'
    ),
    meta: {
      title: 'Edit Group Certificate ',
      requiresAuth: true,
      pageTitle: 'Group Certificate',
      breadcrumb: [
        {
          text: 'Group certificate',
          to: '/group-certificate',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
